module.exports = __webpack_public_path__ + "static/img/backTopbg.d192ef23.png";